export const DAILY_DEALS_POPUP_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000
export const DAILY_DEALS_POPUP_DELAY_MS = 15_000
export const DAILY_DEALS_GUEST_SUBSCRIBED_KEY = 'dailyDealsGuestSubscribed'

export function dailyDealsPopupEligible({
  active,
  ready,
  signedIn,
  membershipKnown,
  subscribed,
  guestSubscribed,
  lastShown,
  now,
}: {
  active: boolean
  ready: boolean
  signedIn: boolean
  membershipKnown: boolean
  subscribed: boolean
  guestSubscribed: boolean
  lastShown: number
  now: number
}) {
  return (
    active &&
    ready &&
    (signedIn ? membershipKnown && !subscribed : !guestSubscribed) &&
    (lastShown === 0 || now - lastShown >= DAILY_DEALS_POPUP_COOLDOWN_MS)
  )
}

/** Support conversations must remain uninterrupted, including while their window is closed. */
export function dailyDealsPopupAllowedOnPath(pathname: string | null) {
  return (
    pathname != null &&
    pathname !== '/support-chat' &&
    !pathname.startsWith('/support-chat/')
  )
}
